import { DEFAULT_FILTERS_STORE } from '../store'

/**
 * Check if is filtering
 *
 * @param {Object} state
 * @return {*|boolean}
 */
function isFiltering(state) {
    return state.name && state.name !== ''
}

/**
 * Set search value
 *
 * @param {Object} state
 * @param {string} element
 * @param {string} value
 * @return {*}
 */
function setValue(state, element, value) {
    return {
        ...state,
        [element]: value,
        isFiltering: isFiltering(state),
    }
}

/**
 * Reset filters to default state
 *
 * @return {*}
 */
function resetFilters(state) {
    return {
        ...DEFAULT_FILTERS_STORE,
        isWhitelistedRoute: state.isWhitelistedRoute,
    }
}

/**
 * Set if is whitelisted route defined in router
 *
 * @param {Object} state
 * @param {Boolean} isWhitelistedRoute
 * @return {{isWhitelistedRoute: boolean}}
 */
function setIsWhitelistedRoute(state, isWhitelistedRoute) {
    return {
        ...state,
        isWhitelistedRoute: isWhitelistedRoute,
    }
}

/**
 * @param {Object} state
 * @param {Object} action
 * @return {*}
 */
export default function (state = [], action) {
    switch (action.type) {
        case 'FILTERS_SET_VALUE': return setValue(state, action.element, action.value)
        case 'FILTERS_SET_NAME': return setValue(state, 'name', action.value)
        case 'FILTERS_RESET': return resetFilters(state)
        case 'FILTERS_SET_IS_WHITELISTED_ROUTE': return setIsWhitelistedRoute(state, action.isWhitelistedRoute)
        default: return state
    }
}
